module.exports = __webpack_public_path__ + "img/add-tag.f7a41902.svg";